webpackJsonp([6],{

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

var _vue = __webpack_require__(2);

var _vue2 = _interopRequireDefault(_vue);

var _animejs = __webpack_require__(3);

var _animejs2 = _interopRequireDefault(_animejs);

__webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Header',

    data: {
        interactions: true,
        mobileMenuOpen: false
    },

    mounted: function mounted() {
        var _this = this;

        _lodash2.default.each(this.$refs.mobileMenu.querySelectorAll('a'), function (a) {
            a.addEventListener('click', function (e) {
                var subMenu = a.parentNode.querySelector('ul.sub-menu');
                if (subMenu) {
                    e.preventDefault();
                    _this.toggleList(subMenu, true);
                }
            });
        });
    },


    methods: {
        toggleMobileMenu: function toggleMobileMenu() {
            if (!this.interactions) {
                return;
            }

            this.mobileMenuOpen = !this.mobileMenuOpen;
            this.toggleList(this.$refs.mobileMenu.querySelector('ul.menu'));
        },
        toggleList: function toggleList(ul) {
            var _this2 = this;

            var isSub = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.interactions = false;

            if (isSub) {
                this.$refs.mobileMenu.querySelector('ul.menu').style.height = 'auto';
            }

            if (ul.offsetHeight === 0) {
                if (isSub) {
                    ul.style.height = 'auto';
                }

                // open menu
                _vue2.default.nextTick(function () {
                    (0, _animejs2.default)({
                        targets: ul,
                        height: [0, ul.offsetHeight],
                        duration: 1000,
                        easing: 'easeInOutQuint',
                        complete: function complete() {
                            _this2.interactions = true;
                            // ul.style.height = null
                        }
                    });
                });
            } else {
                // close menu
                (0, _animejs2.default)({
                    targets: ul,
                    height: 0,
                    duration: 1000,
                    easing: 'easeInOutQuint',
                    complete: function complete() {
                        _this2.interactions = true;
                        ul.style.height = null;
                    }
                });
            }
        }
    }
};

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// app-6-1ef45c81556bd9451a13.js